import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { AffichageCGUService } from '../affichage-cgu/services/affichage-cgu.service';
import { CustomCookieService } from '../../services/custom-cookie.service';

@Component({
  selector: 'app-cookie-error',
  templateUrl: './cookie-error.component.html',
  styleUrls: ['./cookie-error.component.css'],
})
export class CookieErrorComponent implements OnInit {
  constructor(
    private cookieService: CustomCookieService,
    private router: Router,
    private translate: TranslateService,
    private readonly affichageCGUService: AffichageCGUService
  ) {}

  ngOnInit(): void {}

  acceptCookies(): void {
    this.cookieService.grantConsent();
    this.router.navigate(['/']);
  }

  clearCookiesAndLogout(): void {
    this.cookieService.revokeConsent();
    this.router.navigate(['/auth/login']);
  }

  downloadDocument(): void {
    this.affichageCGUService.getPdf('COOKIES').subscribe(
      (blob: Blob): void => {
        // @ts-ignore
        const file = new Blob([blob], { type: 'application/pdf' });
        const fileURL = URL.createObjectURL(file);
        window.open(fileURL);
      }
    );
  }
}
